<template>
  <div :class="classes">
    <pt-page-title :title="(isEdit?'编辑':'新建')+'新闻分类'" class="news-form-title"></pt-page-title>
    <pt-sub-title title="新闻分类"></pt-sub-title>
    <table :class="$style['categories-form-table']">
        <pt-form-list-item label="分类名称：" :required="true">
            <wt-input v-model="formValue.name" data-vv-as="分类名称" v-validate="'required'" name="name"></wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="展示图标：">
            <wt-upload-file :action="uploadApi" :data="upload_params" :img-url="privateResourcesUrl"
                :multiple="false" v-model="formValue.extensionInfo.icon">
                    <i v-if="!formValue.icon" class="iconfont icon-Group1 main-color" :class="$style['add-group-pictrue']"></i>
            </wt-upload-file>
        </pt-form-list-item>
        <pt-form-list-item label="新闻排序：" :required="true" >
            <wt-selector data-vv-as="新闻排序" v-model="formValue.extensionInfo.sort" :options="classifySortord" name="type" v-validate="'required'"></wt-selector>
        </pt-form-list-item>
    </table>
    <template v-if="isEdit">
        <pt-sub-title title="新闻列表"></pt-sub-title>
        <pt-news-manage :isTitle="false" :paramsData="paramsData"></pt-news-manage>
        <!-- <pt-news-table  :tableLabels="tableLabels" :paramsData="paramsData">
            <el-table-column label="操作">
            <template slot-scope="scope">
            <el-button type="text" @click="detail(scope.row)">详情</el-button>
            <el-button type="text" v-if="scope.row.state=='PUBLISHED'" @click="disabled(scope.row)">下架</el-button>
            <template v-else>
                <el-button type="text" v-if="scope.row.state=='DRAFT'" @click="publish(scope.row)">发布</el-button>
                <el-button type="text" @click="editNews(scope.row)">编辑</el-button>
                <el-button type="text" @click="deleteNews(scope.row)">删除</el-button>
            </template>
          </template>
            </el-table-column>
        </pt-news-table> -->
    </template>
  </div>
</template>

<script>
import ptNewsManage from '../../../pt-news-manage/withData'
import { tableLabels, classifySortord } from '../../news-option'
import formMixins from 'mixins/form'
// 组件class前缀
const prefixCls = 'pt-news-classify-form'

export default {
  name: 'pt-news-classify-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },

  components: {
    ptNewsManage
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: function () {
        return {
          extensionInfo: {
            sort: null
          }
        }
      }
    }
  },
  data () {
    return {
      formValue: this.form,
      uploadApi: this.$uploadApi,
      privateResourcesUrl: this.$publicResourcesUrl,
      upload_params: {
        resourceName: 'news',
        objectId: this.id || 0
      },
      tableLabels: tableLabels,
      paramsData: {
        categoryId: this.id
      },
      sort: '',
      classifySortord: classifySortord
    }
  },
  watch: {
    form: {
      handler: function (val) {
        this.formValue = val
      }
    },
    sort (val) {
      this.formValue.extensionInfo.sort = val
    }
  },
  methods: {
    detail (val) {
      this.$router.push('/news-manage/news-detail/' + val.id)
    }
  },
  created () {
    this.formValue.extensionInfo = this.formValue.extensionInfo || { sort: null }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.categories-form-table{
    padding: 10px 20px;
    max-width: 350px;
        :global
        .el-upload-list__item{
            border: none;
            .el-upload-list__item-status-label{
                display: none
            }
        }
        :global
    .el-upload--picture-card{
        width: 0;
        height: 0;
        border: none;
        line-height:30px;
        display: initial
    }
}
.add-group-pictrue{
    font-size: 30px;
}

</style>
